import { render } from "./ShareFriend.vue?vue&type=template&id=2c6e8951&scoped=true"
import script from "./ShareFriend.vue?vue&type=script&lang=js"
export * from "./ShareFriend.vue?vue&type=script&lang=js"

import "./ShareFriend.vue?vue&type=style&index=0&id=2c6e8951&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6e8951"]])

export default __exports__